import React, { useState } from "react";
import { Navbar, Container, Nav, Row, Button, Image } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import './Navigation.css'
import { useAuth } from '../contexts/AuthContext'
import { useHistory } from 'react-router-dom'

function Navigation() {

    const [setError] = useState("")
    const { logout } = useAuth()

    const history = useHistory()

    async function handleLogout() {
        setError("")

        try {
            await logout()
            history.push("/")
        } catch {
            setError('Failed to log out.')
        }
    }

    return (
        <Container>
            <Row>
                <Navbar bg="dark" variant="dark" expand="lg">
                    <Container>
                        <LinkContainer to="/scan"><Navbar.Brand><Image style={{ maxWidth: "80px", height: "auto" }} src="/proion-logo.png" /></Navbar.Brand></LinkContainer>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="me-auto">
                                <LinkContainer to="/scan"><Nav.Link>Search code</Nav.Link></LinkContainer>
                                <LinkContainer to="/products"><Nav.Link>Products</Nav.Link></LinkContainer>
                                <LinkContainer to="/list"><Nav.Link>Favorites</Nav.Link></LinkContainer>
                            </Nav>
                            <Button variant="link" className="logout-link" onClick={handleLogout}>Log Out</Button>
                        </Navbar.Collapse>

                    </Container>
                </Navbar>
            </Row>
        </Container>

    )
}

export default Navigation